/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClearCompanyLogoUrlsResponse
 */
export interface ClearCompanyLogoUrlsResponse {
    /**
     * 
     * @type {number}
     * @memberof ClearCompanyLogoUrlsResponse
     */
    clearedCount: number;
}

/**
 * Check if a given object implements the ClearCompanyLogoUrlsResponse interface.
 */
export function instanceOfClearCompanyLogoUrlsResponse(value: object): value is ClearCompanyLogoUrlsResponse {
    if (!('clearedCount' in value) || value['clearedCount'] === undefined) return false;
    return true;
}

export function ClearCompanyLogoUrlsResponseFromJSON(json: any): ClearCompanyLogoUrlsResponse {
    return ClearCompanyLogoUrlsResponseFromJSONTyped(json, false);
}

export function ClearCompanyLogoUrlsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClearCompanyLogoUrlsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clearedCount': json['clearedCount'],
    };
}

export function ClearCompanyLogoUrlsResponseToJSON(value?: ClearCompanyLogoUrlsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clearedCount': value['clearedCount'],
    };
}

